"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable import/no-cycle */
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const context_1 = require("../../../context");
const MediaContainer_1 = tslib_1.__importDefault(require("../MediaContainer/MediaContainer"));
const PlayerVideo_1 = tslib_1.__importDefault(require("../Videos/PlayerVideo"));
const __1 = require("..");
const ControlBar_1 = tslib_1.__importDefault(require("../../../ui-lib/ControlBar"));
const styling_1 = require("../../../styling");
const Close_1 = tslib_1.__importDefault(require("../../../ui-lib/Icons/Close"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const styles_1 = require("./styles");
const Eye_1 = tslib_1.__importDefault(require("../../../ui-lib/Icons/Eye"));
const MultistreamPlayer = (0, mobx_react_lite_1.observer)(({ classes, publicKey, useDefaultStyles = true, reRender }) => {
    var _a;
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.playerStyles }, "multistream");
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamPlayer/>");
    const { playersWrapperElement, activePublicKeys, stopPlayer, streams } = ctx;
    const stream = streams[publicKey];
    const { offsetHeight, offsetWidth } = (_a = playersWrapperElement.current) !== null && _a !== void 0 ? _a : { offsetHeight: 0, offsetWidth: 0 };
    const defaultStyles = (0, react_1.useMemo)(() => (0, styles_1.getVideoElementStyles)({
        containerHeight: offsetHeight,
        containerWidth: offsetWidth,
        playersCount: activePublicKeys.length,
    }), [activePublicKeys.length, offsetHeight, offsetWidth]);
    const viewCount = stream === null || stream === void 0 ? void 0 : stream.viewCount;
    return (react_1.default.createElement(MediaContainer_1.default, { classes: useDefaultStyles
            ? {
                root: {
                    ...defaultStyles.root,
                    ...classes === null || classes === void 0 ? void 0 : classes.root,
                },
            }
            : classes },
        activePublicKeys.length !== 1 && (react_1.default.createElement("button", { type: "button", onClick: () => stopPlayer(publicKey), className: mergedClasses.closeButton },
            react_1.default.createElement(Close_1.default, { weight: "normal", style: { width: "15px", marginLeft: "3px" } }))),
        react_1.default.createElement(PlayerVideo_1.default, { pillarBox: false }),
        react_1.default.createElement(ControlBar_1.default, { variant: "player", classes: {
                root: { bottom: "0 !important" },
                controls: { backgroundImage: "transparent", justifyContent: "flex-start" },
            } },
            react_1.default.createElement(__1.PlayerPlayButton, null),
            react_1.default.createElement(__1.PlayerAudioButton, null)),
        viewCount != null && viewCount > 0 && (react_1.default.createElement("div", { className: mergedClasses.viewCount },
            react_1.default.createElement(Eye_1.default, { style: { width: "15px", marginRight: "3px", height: "11px" } }),
            react_1.default.createElement("span", null, viewCount)))));
});
exports.default = MultistreamPlayer;
//# sourceMappingURL=MultistreamPlayer.js.map